import React, { useEffect, useMemo } from 'react';
import arrow from '../../../common/images/revamp/icon/arrow-black.svg';
import chevron from '../../../common/images/revamp/icon/chevron-black.svg';
import { formatDate, formatRupiah, sendAnalyticsPageView } from '../../../utils/helper';
import useVoucherDetail from './useVoucherDetail';
import { twMerge } from 'tailwind-merge';
import { TNCIcon } from '../../../utils/svg';
import ImageLoader from '../../ImageLoader';
import moment from 'moment';

const VoucherDetail = ({ data, onClose }) => {
	const { expand, handleExpand } = useVoucherDetail();

	useEffect(() => {
		sendAnalyticsPageView('terms_session');
	}, []);

  const renderDescription = (description) => {
    if (!description) return null;
  
    return (
      <div
        className="text-gray-500 text-xs mb-20 [&_ol]:list-decimal [&_ul]:list-disc [&_li]:ml-4 [&_strong]:text-gray-700"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    );
  };

  const expired = useMemo(() => {
    if (data?.periode_type === "date_range") {
      return `Expired ${formatDate(data?.end_date, 'DD MMM YYYY')}`
    }

    if (data?.periode_type === "day_time") {
      const todayName = moment().format("dddd");
      const now = moment();
      const todaySchedule = data.day_scope?.find(
        (d) => d.day.toLowerCase() === todayName.toLowerCase()
      );
  
      const start = moment(todaySchedule.start_time, "HH:mm");
      const end = moment(todaySchedule.end_time, "HH:mm");
  
      if (now.isBefore(start)) {
        return `Mulai jam ${todaySchedule.start_time}`;
      }
  
      if (now.isBetween(start, end)) {
        return `Expired Jam ${todaySchedule.end_time}`;
      }
  
      return "Expired";
    }
    return null;
  }, [data])

	return (
		<>
			<div className='fixed !z-[100000] w-full h-full top-0 left-0 bg-gray-100 pointer-events-auto'>
				<div className='p-2.5 flex items-center gap-1.5 border-b border-solid border-gray-300 bg-white'>
					<img src={arrow} alt='arrow-left w-8 h-8 cursor-pointer' onClick={() => onClose?.()} id='terms_voucher_detail_back' />
					<span className='text-gray-900 font-semibold capitalize'>Detail Promo</span>
				</div>
				<div className={`${expand ? '!h-full overflow-y-scroll' : 'h-auto'}`}>
					<ImageLoader src={data?.image} className='h-auto max-h-36 w-full object-cover object-center border-1 border-solid border-gray-100 bg-gray-200' />
					<div className='w-full p-4 mb-2 bg-white'>
						<div className=''>
							<div className='font-bold text-base text-gray-700'>{data?.code}</div>
							<p className="font-thin text-xs">{data?.short_description}</p>
							<div className='flex justify-between w-full'>
								<div className='space-y-2 pt-4 max-w-[70%]'>
									<div className='text-gray-500 font-thin text-xs'>Valid until</div>
									<div className='text-gray-500 font-thin text-xs'>Minimum transaction</div>
								</div>
								<div className='space-y-2 pt-4'>
									<div className='text-gray-600 font-medium text-xs'>{expired}</div>
									<div className='text-gray-600 font-medium text-xs'>{formatRupiah(data?.min_transaction || 0)}</div>
								</div>
							</div>
              <div className='text-gray-500 font-thin text-xs pt-2'>Voucher tidak bisa digabungkan dengan voucher lainnya</div>
						</div>
					</div>
					<div className='transition-all w-full min-h-full bg-white'>
						<div className='px-4 py-2 flex justify-between items-center gap-5 transition-all border-gray-200 border-b-1 border-solid' onClick={() => handleExpand('tnc')} id='terms_view_t&c'>
							<div className='flex gap-2 items-center'>
								<TNCIcon className='fill-[var(--rose-violet)]' />
								<div className='[&>*]:mb-0'>
									<p className='font-semibold text-xs text-gray-900'>Syarat & Ketentuan</p>
									<p className='text-xxs text-gray-500'>Klik untuk melihat syarat dan ketentuan</p>
								</div>
							</div>
							<img src={chevron} alt='chevron' className={twMerge('transition-all -rotate-180', expand === 'tnc' && 'rotate-0')} />
						</div>
						<p className={twMerge('h-0 px-3 pt-3 pb-3 hidden m-0 transition-all duration-300', expand === 'tnc' && 'h-full block')}>{renderDescription(data?.terms)}</p>
					</div>
				</div>
			</div>
		</>
	);
};

export default VoucherDetail;
